import Storage from "../../../helpers/Storage";
import Roles from "../../constants/Roles";
import storage from "../../../helpers/Storage";

export default class User {

  static checkRole = (role, includeAdmin) => {
    let roles = parseInt(Storage.getRoles());
    return this.checkRole2(roles, role, includeAdmin);
  }

  static checkRole2 = (roles, role) => {
    return (roles & role) === role;
  }


  static checkHasAnyRole = (roles) => {
    for (let role of roles) {
      if (this.checkRole(role)) {
        return true;
      }
    }

    return false;
  }

  static isGuest = () => {
    let res = Storage.getRoles() ;
    return ( res );
  }

  static isAdmin = () => {
    return this.checkRole(Roles.ROLE_ADMIN);
  }
  static isAdminByRole = (role) => {
    return this.checkRole2(role, Roles.ROLE_ADMIN);
  }

  static isTypist = () => {
    return this.checkRole(Roles.ROLE_TYPIST);
  }
  static isTypistByRole = (role) => {
    return this.checkRole2(role, Roles.ROLE_TYPIST);
  }
  static isTypistByID = (id) => {
    let role = storage.getUsersInfo(id)?.roles
    return this.isTypistByRole(role);
  }

  static isStaff = () => {
    return this.checkRole(Roles.ROLE_STAFF);
  }
  static isStaffByRole = (role) => {
    return this.checkRole(role, Roles.ROLE_STAFF);
  }
  static isStaffByID = (id) => {
    let role = storage.getUsersInfo(id)?.roles
    return this.isStaffByRole(role);
  }

  static isResident = () => {
    return this.checkRole(Roles.ROLE_RESIDENT);
  }
  static isResidentByRole = (role) => {
    return this.checkRole(role, Roles.ROLE_RESIDENT);
  }
  static isResidentByID = (id) => {
    let role = storage.getUsersInfo(id)?.roles
    return this.isResidentByRole(role);
  }

  static isAssistant = () => {
    return this.checkRole(Roles.ROLE_ASSISTANT);
  }
  static isAssistantByRole = (role) => {
    return this.checkRole2(role, Roles.ROLE_ASSISTANT);
  }
  static isAssistantByID = (id) => {
    let role = storage.getUsersInfo(id)?.roles
    return this.isAssistantByRole(role);
  }

  static isAccount = () => {
    return this.checkRole(Roles.ROLE_ACCOUNT);
  }

}
